module.exports = __webpack_public_path__ + "static/media/IMG_3482_sm.34508cd5.jpg";